import { isNil, isNumber } from "lodash";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit, computed, input, signal } from "@angular/core";
import { TranslateService } from "@root/shared/service/translate.service";
import { NzMessageService } from "ng-zorro-antd/message";

@Component({
  selector: "property-detail-pricing-ratio",
  templateUrl: "./pricing-ratio.component.html",
  styleUrls: ["./pricing-ratio.component.scss"],
})
export class PricingRatioComponent implements OnInit {
  type = input<"house" | "type">("house");
  id = input.required<number>();
  enablePriceRatio = false;

  listOfPriceRatio = [];
  listOfPriceOptout = [];

  isHouse = computed(() => {
    return this.type() === "house";
  });

  //#region Api
  readonly FetchPriceRatioApi = computed(() => {
    return this.isHouse() ? "/api/house/listing_price_ratio" : "/api/house_type/listing_price_ratio";
  });
  readonly UpdatePriceRatioApi = computed(() => {
    return this.isHouse() ? "/api/house/set_listing_price_ratio" : "/api/house_type/set_listing_price_ratio";
  });
  readonly UpdatePrStatusApi = computed(() => {
    return this.isHouse()
      ? "/api/house/set_listing_price_ratio_status"
      : "/api/house_type/set_listing_price_ratio_status";
  });
  readonly FetchPriceOptoutApi = computed(() => {
    return this.isHouse() ? "/api/house/smart_price_optout" : "/api/house_type/smart_price_optout";
  });

  readonly UpdatePriceOptoutApi = computed(() => {
    return this.isHouse() ? "/api/house/set_smart_price_optout" : "/api/house_type/set_smart_price_optout";
  });
  //#endregion

  //#region ShowAllListings
  showMorePriceRatioChannel = signal<boolean>(false);
  showMorePriceOptout = signal<boolean>(false);
  readonly showMoreListingsLimit = 4;
  showMorePRCText = computed(() => {
    return this.showMorePriceRatioChannel()
      ? this.t.t("property-property_detail-pricing-ratio_html_spo_less")
      : this.t.t("property-property_detail-pricing-ratio_html_spo_more", {
          number: this.listOfPriceRatio.length - this.showMoreListingsLimit,
        });
  });
  showMorePOText = computed(() => {
    return this.showMorePriceOptout()
      ? this.t.t("property-property_detail-pricing-ratio_html_spo_less")
      : this.t.t("property-property_detail-pricing-ratio_html_spo_more", {
          number: this.listOfPriceOptout.length - this.showMoreListingsLimit,
        });
  });
  //#endregion

  constructor(
    private t: TranslateService,
    private http: HttpClient,
    private msg: NzMessageService,
  ) {}

  ngOnInit() {
    this.fetchPriceRatio();
    this.fetchSmartPriceOptout();
  }

  //#region Price Ratio
  private fetchPriceRatio() {
    const params = {
      [this.isHouse() ? "house_id" : "house_type_id"]: this.id(),
    };
    this.http.get(this.FetchPriceRatioApi(), { params }).subscribe((rst: any) => {
      this.enablePriceRatio = !!rst?.data?.status;
      this.listOfPriceRatio = rst?.data?.list || [];
    });
  }

  private requestUpdatePriceRatioStatus() {
    const params = {
      [this.isHouse() ? "house_id" : "house_type_id"]: this.id(),
      status: this.enablePriceRatio ? 1 : 0,
    };
    this.http.post(this.UpdatePrStatusApi(), params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        /**
         * 重新刷新一下
         */
        if (this.enablePriceRatio) {
          this.fetchPriceRatio();
        }
      }
    });
  }

  private requestUpdatePriceRatio() {
    console.log("this.list of price ratio:", this.listOfPriceRatio);
    if (this.listOfPriceRatio.some((item) => !item.readonly && isNil(item.ratio))) {
      return this.msg.error(this.t.t("property-property_detail-pricing-ratio_html_warning_no_empty"));
    } else if (this.listOfPriceRatio.some((item) => !item.readonly && !isNumber(item.ratio))) {
      return this.msg.error(this.t.t("property-property_detail-pricing-ratio_html_warning_no_number"));
    }
    const params = {
      [this.isHouse() ? "house_id" : "house_type_id"]: this.id(),
      list: this.listOfPriceRatio,
    };

    this.http.post(this.UpdatePriceRatioApi(), params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.msg.success(this.t.t("success.save"));
      }
    });
  }

  onPrStatusChange() {
    this.requestUpdatePriceRatioStatus();
  }

  onSavePriceRatio() {
    this.requestUpdatePriceRatio();
  }

  //#endregion

  //#region Smart Price Opt out
  private fetchSmartPriceOptout() {
    const params = { [this.isHouse() ? "house_id" : "house_type_id"]: this.id() };
    this.http.get(this.FetchPriceOptoutApi(), { params }).subscribe((rst: any) => {
      this.listOfPriceOptout = (rst?.data?.list || []).map((item) => ({
        ...item,
        price: !!item.price,
        restriction: !!item.restriction,
      }));
    });
  }

  private requestUpdateSmartPriceOptout() {
    const params = {
      [this.isHouse() ? "house_id" : "house_type_id"]: this.id(),
      list: this.listOfPriceOptout.map((item) => ({
        ...item,
        price: +item.price,
        restriction: +item.restriction,
      })),
    };
    this.http.post(this.UpdatePriceOptoutApi(), params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.msg.success(this.t.t("success.save"));
      }
    });
  }

  onSavePriceOptout() {
    this.requestUpdateSmartPriceOptout();
  }
  //#endregion
}
